/** The horizontal position on the canvas */
type XPosition = number;
/** The vertical position on the canvas */
type YPosition = number;
/**
 * The command instructing how the line should be drawn
 * See: https://www.w3schools.com/graphics/svg_path.asp
 */
type PathCommand = 'M' | 'L';
type PathTuple = [PathCommand, XPosition, YPosition];

interface GetLinePathArgs {
  /** Starting x */
  startX: XPosition;
  /** Starting y */
  startY: YPosition;
  /** Ending x */
  endX: XPosition;
  /** Ending y */
  endY: YPosition;
}

/**
 * Gets the path values for a line
 */
export const getLinePath = ({ startX, startY, endX, endY }: GetLinePathArgs): PathTuple[] => [
  ['M', startX, startY],
  ['L', endX, endY],
];

interface GetHorizontalLinePathArgs {
  /** Starting x */
  x: XPosition;
  /** y position */
  y: YPosition;
  /** Width of the line */
  width: number;
}

/**
 * Gets the path values for a horizontal line
 */
export const getHorizontalLinePath = ({ x, y, width }: GetHorizontalLinePathArgs): PathTuple[] =>
  getLinePath({ startX: x, startY: y, endX: x + width, endY: y });
